import { c as _c } from "react/compiler-runtime";
import { hasCmsPreview } from '@/globals/config/hasCmsPreview.config';
import { translateInline } from '@/globals/translate/translateInline';
import { useWebStorageStore } from '@/globals/webStorage/useWebStorage';
import { store } from '@/sections/editorWidget/EditorWidget.client.loader';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { position } from '@/uiPrimitives/layout/position';
import { textBlock } from '@/uiPrimitives/typography/text';
export const TitlePrefix = t0 => {
  const $ = _c(12);
  const {
    titlePrefix,
    className,
    style
  } = t0;
  const [opened] = useWebStorageStore(store, hasCmsPreview);
  if (!titlePrefix) {
    return null;
  }
  if (!opened) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = classes(box({
      paddingInlineEnd: "-2 | smaller",
      inlineSize: "max-content"
    }), position({
      position: "absolute",
      insetBlockStart: "0",
      insetInlineEnd: "100%"
    }), className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classes(box({
      padding: "-2 | smaller",
      backgroundColor: "negativeGray",
      borderRadius: "2px",
      borderStyle: "dashed",
      borderWidth: "1px",
      borderColor: "positiveMuted"
    }), textBlock({
      capSize: "-1 | small",
      color: "positiveMuted"
    }));
    t3 = translateInline({
      nl: "Alleen zichtbaar als de Redactie Widget open is",
      en: "Only visible when the Editorial Widget is open"
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== titlePrefix) {
    t4 = <span className={t2} title={t3}>{titlePrefix}</span>;
    $[4] = t2;
    $[5] = t3;
    $[6] = titlePrefix;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== style || $[9] !== t1 || $[10] !== t4) {
    t5 = <span className={t1} style={style}>{t4}</span>;
    $[8] = style;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};